import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    © 2025 KetelsenCoding
  </footer>
);

export default Footer;
